import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  Stack,
  Typography,
  Grid,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogContentText,
  DialogActions,
  IconButton
} from '@mui/material';
import { Close, MyLocationOutlined, Search } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { MdArrowDropDown } from 'react-icons/md';
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
  InfoWindow
} from '@react-google-maps/api';
import iconMarker from '../../../../src/components/google-map-icon/marker.svg';
import iconLocation from '../../../../src/components/google-map-icon/arrow_circle.svg';
import CloseIcon from '@mui/icons-material/Close';
// import selfRegistrationPage from '../../services/selfRegistrationPage';
import fakeArrayDelete from '../../../services/fakeArrayDelete';
// import Validation from '../../global/Validation';
import Loader from '../../global/Loader';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import { userDataFromLocal } from '../utils/getUserDetails';
import { TiLocation } from 'react-icons/ti';

const { GetNearByShops } = onBoardingEkycServices;

const Contact = () => {
  const googleKey = process.env.REACT_APP_GoogleApi_Key;

  // const [currentLocation, setCurrentLocation] = useState();
  const [currentLocation, setCurrentLocation] = useState('');
  // const [currentLocation, setCurrentLocation] = useState({
  //   position: { lat: 21.18843, log: 72.84014 }
  // });
  const [getNearByShopsResponse, setGetNearByShopsResponse] = useState([]);
  const [openloader, setOpenloader] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  const [isAutocomplete, setAutocomplete] = useState(null);
  const [searchedLocation, setsearchedLocation] = useState(null);
  const [myCurrntLocation, setMyCurrentLocation] = useState(null);
  const [openValidation, setOpenValidation] = useState(false);
  const [open, setOpen] = useState(false);
  const [zoom, setZoom] = useState(13);
  const [refreshComp, setRefreshed] = useState(null);
  const [showSingleLocation, setShowSingleLocation] = useState(true);
  const [singleLocationData, setSingleLocationData] = useState([]);
  const [inputAutocompleteValue, setInputAutocompleteValue] = useState('');
  const [validationMsg, setValidationMsg] = useState('');
  const [validationMsg2, setValidationMsg2] = useState('');

  // first dialog box click handler
  const handleClickOpenFirstDialogBox = () => {
    setOpen(true);
  };

  const handleClickfirstDialogBox = () => {
    setOpen(false);
  };

  const getLocation = async () => {
    let position = {};
    let positionForApi = '';
    function showPosition(position) {
      setCurrentLocation({
        Latitude: position.coords.latitude,
        Longitude: position.coords.longitude
      });
      position = {
        Latitude: position.coords.latitude,
        Longitude: position.coords.longitude
      };
    }

    navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
      if (permissionStatus.state == 'prompt') {
        // ask for permission and set it to local storage
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(showPosition);
        } else {
        }
      }

      if (permissionStatus.state === 'granted') {
        navigator.geolocation.getCurrentPosition(function (geoposition) {
          const newPosition = {
            Latitude: geoposition.coords.latitude,
            Longitude: geoposition.coords.longitude
          };

          positionForApi = newPosition;

          setCurrentLocation({
            Latitude: geoposition.coords.latitude,
            Longitude: geoposition.coords.longitude
          });
          setZoom(12);
          GetNearByShopsApi(geoposition.coords.latitude, geoposition.coords.longitude);
          setMyCurrentLocation({
            lat: geoposition.coords.latitude,
            lng: geoposition.coords.longitude
          });
        });
      }

      if (permissionStatus.state == 'denied') {
        handleClickOpenFirstDialogBox();
      }
      ///////////////////////////////////////////////////////////// location on change event ////////////////////////////////
      permissionStatus.onchange = () => {
        if (permissionStatus.state == 'prompt') {
        }
        if (permissionStatus.state == 'granted') {
          // get location
          navigator.geolocation.getCurrentPosition(function (geoposition) {
            const newPosition = {
              Latitude: geoposition.coords.latitude,
              Longitude: geoposition.coords.longitude
            };
            setCurrentLocation({
              Latitude: geoposition.coords.latitude,
              Longitude: geoposition.coords.longitude
            });
            // change position to geoposition in code below
            GetNearByShopsApi(geoposition.coords.latitude, geoposition.coords.longitude);
            setMyCurrentLocation({
              lat: geoposition.coords.latitude,
              lng: geoposition.coords.longitude
            });
          });

          setOpenValidation(false);
          setValidationMsg('');
        }
        if (permissionStatus.state == 'denied') {
          setCurrentLocation('');

          handleClickOpenFirstDialogBox();
        }
      };
    });
  };

  const handleClose = () => {
    setOpenValidation(false);
  };

  // Near by shops API
  const GetNearByShopsApi = async (lat, log) => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();
      const hdrCredential = {
        log: 72.84014,
        latt: 21.18843,
        // log: log,
        // latt: lat,
        // applicationNo: userData ? userData?.applicationNo : '',
        // applicationNo: '2497d6f9-1e95-4ea5-ab2f-40264132ab6e',
        applicationNo: 1,
        APIKey: '8c6f9f2d-7765-4f14-81b8-7ceddb3cd14d'
      };
      const GetNearByShopsResponse = await GetNearByShops(hdrCredential);
      if (GetNearByShopsResponse.status === 'Success') {
        setGetNearByShopsResponse(GetNearByShopsResponse.data);
      } else if (GetNearByShopsResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(GetNearByShopsResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(
          GetNearByShopsResponse?.message ? GetNearByShopsResponse?.message : 'Server error'
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      console.log('navigator', navigator);
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          // Latitude: position.coords.latitude,
          // Longitude: position.coords.longitude
          Latitude: 21.18843,
          Longitude: 72.84014
        });
        GetNearByShopsApi(position.coords.latitude, position.coords.longitude);
        setMyCurrentLocation({
          // lat: position.coords.latitude,
          // lng: position.coords.longitude
          lat: 21.18843,
          lng: 72.84014
        });
      });
    } else {
      setCurrentLocation(currentLocation);
      GetNearByShopsApi(currentLocation.Latitude, currentLocation.Longitude);
      setMyCurrentLocation({
        // lat: currentLocation.Latitude,
        // lng: currentLocation.Longitude
        lat: 21.18843,
        lng: 72.84014
      });
    }
  }, []);

  const getCurrentLocationClick = () => {
    setShowSingleLocation(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        GetNearByShopsApi(position.coords.latitude, position.coords.longitude);
        setCurrentLocation({
          Latitude: position.coords.latitude,
          Longitude: position.coords.longitude
        });
        setMyCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
        setsearchedLocation(null);
        setZoom(16);
        setInputAutocompleteValue('');
      });
    }
  };

  // Filter Search
  const handleSearch = (e) => {
    if (isAutocomplete && isAutocomplete !== null) {
      if (isAutocomplete.getPlace()) {
        GetNearByShopsApi(
          isAutocomplete.getPlace().geometry.location.lat(),
          isAutocomplete.getPlace().geometry.location.lng()
        );
        setCurrentLocation({
          Latitude: isAutocomplete.getPlace().geometry.location.lat(),
          Longitude: isAutocomplete.getPlace().geometry.location.lng()
        });
        setsearchedLocation({
          lat: isAutocomplete.getPlace().geometry.location.lat(),
          lng: isAutocomplete.getPlace().geometry.location.lng()
        });
        setZoom(12);
        let completeAdd = isAutocomplete.getPlace().name + ', ';
        if (isAutocomplete.getPlace().address_components.length > 0) {
          isAutocomplete.getPlace().address_components.map((item, index) => {
            if (index > 0) {
              completeAdd += item.long_name;
            }
          });
        }
        setInputAutocompleteValue(completeAdd);
        setRefreshed(new Date());
      }
    } else {
    }
  };

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script2',
    googleMapsApiKey: googleKey,
    libraries: ['places']
  });

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Contact" />
      <Container
        maxWidth="lg"
        className="selfRegistrationContainer"
        style={{ position: 'relative' }}
      >
        {/* <Validation
          openValidation={openValidation}
          validationMsg={validationMsg}
          handleClose={handleClose}
          setOpenValidation={setOpenValidation}
        /> */}

        <Box className="ContactSearch" position="relative">
          {/* <Grid container>
            <Grid item xs={12} sm={8} md={12} lg={12}>
              <TextField
                className="gblSearchField"
                placeholder="search"
                type="text"
                fullWidth
                // label="Outlined"
                variant="outlined"
                style={{
                  backgroundColor: '#fff',
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  width: '96.5%'
                }}
                // onChange={(e) => handleSearch(e)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search style={{ color: '#03989a' }} />
                    </InputAdornment>
                  ),
                  className: 'searchLG'
                }}
              />
            </Grid>
          </Grid> */}
          {isLoaded && (
            <Typography mb={2}>
              <GoogleMap mapContainerStyle={{ width: '100%' }} mapContainerClassName="searchMapBox">
                <Autocomplete
                  restrictions={{ country: ['in'] }}
                  onLoad={(autocomplete) => setAutocomplete(autocomplete)}
                  onPlaceChanged={(e) => handleSearch()}
                  className="gblSearchField"
                >
                  <TextField
                    inputProps={{ className: 'formControl' }}
                    // className="gblSearchField"
                    style={{ backgroundColor: '#fff' }}
                    placeholder="Search"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setInputAutocompleteValue(e.target.value)}
                    value={inputAutocompleteValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search style={{ color: '#111b53' }} />
                        </InputAdornment>
                      )
                      // className: 'searchLG'
                    }}
                  />
                </Autocomplete>
              </GoogleMap>
            </Typography>
          )}
        </Box>
        {/* map start from here */}
        <Box>
          {currentLocation !== '' ? (
            <Box>
              <Map
                currentLocation={currentLocation}
                getNearByShopsResponse={getNearByShopsResponse}
                isLoaded={isLoaded}
                refreshComp={refreshComp}
                searchedLocation={searchedLocation}
                myCurrntLocation={myCurrntLocation}
                setCurrentLocation={setCurrentLocation}
                getCurrentLocationClick={getCurrentLocationClick}
                zoom={zoom}
                setZoom={setZoom}
                // t={t}
                setShowSingleLocation={setShowSingleLocation}
                setSingleLocationData={setSingleLocationData}
                singleLocationData={singleLocationData}
                // infoWindowOpen={infoWindowOpen}
                // SetInfoWindowOpen={SetInfoWindowOpen}
              />
            </Box>
          ) : (
            <>
              <Box
                className="errorMsg"
                sx={{
                  background: '#F3E7A8',
                  height: '400px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography variant="h5">
                  Location is not enabled
                  <br />
                  please enable it to proceed
                </Typography>
              </Box>
            </>
          )}
        </Box>

        {/* current location */}
        {currentLocation && (
          <Box className="contactUs" mt={2}>
            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
              {getNearByShopsResponse?.length > 0 && showSingleLocation ? (
                getNearByShopsResponse.map((shop, index) => {
                  return (
                    <Grid item xs={12} sm={6} md={6} key={index}>
                      <Box className="contactList summaryBox">
                        <Typography
                          variant="h6"
                          mb={1}
                          className="FormLabelText summaryLabel"
                          style={{ fontSize: '15px', fontWeight: 'bold' }}
                        >
                          {shop?.shopNameEn}
                        </Typography>
                        <Typography variant="body2" className="FormLabelText">
                          {shop?.fullAddressEn}
                        </Typography>
                      </Box>
                    </Grid>
                  );
                })
              ) : (
                <>
                  <Grid item xs={12}>
                    <Box className="latLongSingleBox">
                      <IconButton
                        onClick={(e) => setShowSingleLocation(!showSingleLocation)}
                        size="small"
                        style={{ position: 'absolute', right: '10px', top: '5px' }}
                      >
                        <Close />
                      </IconButton>
                      {singleLocationData?.length > 0 && !showSingleLocation
                        ? singleLocationData.map((LocationData, index) => {
                            return (
                              <>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    marginBottom: '1rem',
                                    paddingBottom: '0.5rem',
                                    borderBottom: '2px solid #111b53'
                                  }}
                                  className="latLongOnly"
                                >
                                  <Box sx={{ display: 'flex', marginRight: '15px' }}>
                                    <Typography fontWeight="bold">Lat:</Typography>
                                    <Typography>&nbsp;{LocationData.lat}</Typography>
                                  </Box>
                                  <Box sx={{ display: 'flex' }}>
                                    <Typography fontWeight="bold">Long:</Typography>
                                    <Typography>&nbsp;{LocationData.log}</Typography>
                                  </Box>
                                </Box>
                                <Box className="latLongSingleAddress" key={index}>
                                  <Typography
                                    fontWeight="bold"
                                    mb={1}
                                    className="FormLabelText summaryLabel"
                                  >
                                    {LocationData.shopNameEn}
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column'
                                    }}
                                  >
                                    <Box sx={{ display: 'flex', marginBottom: '1.25rem' }}>
                                      <Typography variant="body2" className="mapIcon">
                                        <img src="/static/icons/location.svg" alt="Location" />
                                      </Typography>
                                      <Typography variant="subtitle1" className="FormLabelText">
                                        {LocationData.fullAddressEn}
                                      </Typography>
                                    </Box>
                                    {LocationData.officeHoursEn !== null ? (
                                      <Box sx={{ display: 'flex', marginBottom: '1.25rem' }}>
                                        <Typography variant="body2" className="mapIcon">
                                          <img src="/static/icons/time.svg" alt="Time" />
                                        </Typography>
                                        <Typography variant="body2" className="FormLabelText">
                                          {LocationData.officeHoursEn}
                                        </Typography>
                                      </Box>
                                    ) : (
                                      ''
                                    )}

                                    {LocationData.fax !== null ? (
                                      <Box sx={{ display: 'flex', marginBottom: '1.25rem' }}>
                                        <Typography variant="subtitle1" className="mapIcon">
                                          <img src="/static/icons/fax.svg" alt="Fax" />
                                        </Typography>
                                        <Typography variant="body2" className="FormLabelText">
                                          {LocationData.fax}
                                        </Typography>
                                      </Box>
                                    ) : (
                                      ''
                                    )}

                                    <Box sx={{ display: 'flex' }}>
                                      <Typography variant="body2" className="mapIcon">
                                        <img src="/static/icons/phone.svg" alt="Phone" />
                                      </Typography>
                                      <Typography variant="body2" className="FormLabelText">
                                        {
                                          <a href={`tel:${LocationData.phoneNumber}`}>
                                            {LocationData.phoneNumber},
                                          </a>
                                        }
                                      </Typography>
                                      <Typography variant="body2" className="FormLabelText">
                                        {
                                          <a href={`tel:${LocationData.phoneNumber2}`}>
                                            {LocationData.phoneNumber2}
                                          </a>
                                        }
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              </>
                            );
                          })
                        : ''}
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        )}

        {/* Search field start from here */}
        {/* <Box className="contactUs" mb={4} mt={2}>
          <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            {getNearByShopsResponse.length > 0 &&
              getNearByShopsResponse.map((item, index) => (
                <Grid item xs="12" sm="6" md="6" className="contactList" key={index}>
                  <Typography variant="h6" mb={1} style={{ fontSize: '15px', fontWeight: 'bold' }}>
                    {item?.shopNameEn}
                  </Typography>
                  <Typography variant="body2">{item?.fullAddressEn}</Typography>
                </Grid>
              ))}
          </Grid>
        </Box> */}

        <Dialog
          open={open}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className=""
          classes={{
            paper: 'popUpOuter'
          }}
        >
          <DialogTitle id="alert-dialog-title" className="popUpHead">
            <Box className="popUpIconBox">
              <TiLocation className="popUpIcon" />
            </Box>
          </DialogTitle>
          <DialogContent className="popUpContentB">
            <DialogContentText id="alert-dialog-description" className="popUpBody">
              <Typography variant="subtitle1" className="popUpInnerText">
                Please allow location access permission.
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popUpFoot popUpFootCenter">
            <Button
              className="primaryButton primaryButtonYellow primaryButtonYellowDarkShadow grayColor"
              onClick={(e) => {
                // check if location is denied or allowed
                navigator.permissions &&
                  navigator.permissions
                    .query({ name: 'geolocation' })
                    .then(function (PermissionStatus) {
                      // case 3 if user denied location
                      if (PermissionStatus.state === 'denied') {
                        setOpenValidation(true);

                        setValidationMsg('Location is not enabled');
                        setValidationMsg2('please enable it to proceed');
                      }
                    });

                handleClickfirstDialogBox();
              }}
            >
              Allow
            </Button>
            <Button
              className="primaryButton primaryButtonBlack primaryButtonYellowDarkShadow orangeColor"
              onClick={(e) => handleClickfirstDialogBox(e)}
            >
              not allowed
            </Button>
          </DialogActions>
        </Dialog>

        {/* if user is block by browser or denied then popup */}
        <Dialog
          open={openValidation}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className=""
          classes={{
            paper: 'popUpOuter'
          }}
        >
          <DialogTitle className="popUpHead">
            <Typography variant="h6">&nbsp;</Typography>
            <IconButton onClick={(e) => handleClose()} size="small" className="popUpCloseIcon">
              <CloseIcon size={20} />
            </IconButton>
          </DialogTitle>
          <DialogContent className="popUpContentB">
            <DialogContentText id="alert-dialog-description" className="popUpBody">
              <Typography variant="subtitle1" className="popUpInnerText">
                {validationMsg}
                <br />
                {validationMsg2 !== '' ? validationMsg2 : ''}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popUpFoot popUpFootCenter">
            <Button className="primaryButton" onClick={(e) => handleClose()}>
              Dismiss
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default Contact;

// const containerStyle = {};

function Map({
  currentLocation,
  setCurrentLocation,
  getNearByShopsResponse,
  isLoaded,
  refreshComp,
  searchedLocation,
  myCurrntLocation,
  getCurrentLocationClick,
  zoom,
  setShowSingleLocation,
  setSingleLocationData,
  singleLocationData,
  infoWindowOpen,
  SetInfoWindowOpen
  // setCenter,
  // center
}) {
  const makerRef = useRef();

  const center = {
    lat: parseFloat(currentLocation.Latitude),
    lng: parseFloat(currentLocation.Longitude)
  };

  useEffect(() => {}, [refreshComp]);

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName="googleMapContainer"
      // mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      options={{ gestureHandling: 'greedy', streetViewControl: false, location: true }}
    >
      <Box
        onClick={(e) => getCurrentLocationClick()}
        style={{ position: 'absolute', right: '18px', bottom: '109px', cursor: 'pointer' }}
      >
        <MyLocationOutlined />
      </Box>
      {searchedLocation ? (
        <Marker
          className="customMarker"
          position={searchedLocation}
          icon={{
            url: iconMarker,
            fillColor: '#EB00FF',
            scaledSize: { width: 32, height: 54 }
          }}
          style={{ width: 19 }}
        />
      ) : (
        ''
      )}

      {myCurrntLocation ? (
        <Marker
          className="customMarker"
          position={myCurrntLocation}
          icon={{
            url: iconLocation,
            fillColor: '#EB00FF',
            scaledSize: { width: 30, height: 30 }
          }}
          style={{ width: 19 }}
        />
      ) : (
        ''
      )}

      {getNearByShopsResponse?.length > 0
        ? getNearByShopsResponse.map((position, index) => {
            return (
              <>
                <Marker
                  ref={makerRef}
                  title="marker title"
                  key={index}
                  position={{ lat: position.lat, lng: position.log }}
                  onClick={(e, ev2) => {
                    setShowSingleLocation(false);
                    setSingleLocationData([position]);

                    // setZoom(8);
                    setCurrentLocation({
                      Latitude: position.lat,
                      Longitude: position.log
                    });
                    SetInfoWindowOpen(index);
                  }}
                ></Marker>
              </>
            );
          })
        : ''}

      {/* Child components, such as markers, info windows, etc. */}
      <></>
    </GoogleMap>
  ) : (
    <>
      <Box
        className="errorMsg"
        zIndex={1000}
        display="flex"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
      >
        <Typography> Location is not enabled, please enable it to proceed </Typography>
      </Box>
    </>
  );
}
